// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import Button from '../controls/PrimaryButton'
import Modal from '../FieldSet/Modal'
import LabeledWrapper from '../AudienceEdit/LabeledWrapper'
import { linkColor } from '../controls/colors'

const TextInput: StyledComponent<Object, any, any> = styled.input`
  width: 100%;
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 15px;
  margin: 0 5px 0 0;
  text-align: left;
`
const Link: StyledComponent<Object, any, any> = styled.a`
  display: inline-block;
  font-size: 14px;
  padding-left: 5px;
  text-decoration: underline;
  color: ${linkColor};
`
const TextWrapper: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  padding-bottom: 16px;
`
const HintText: StyledComponent<Object, any, any> = styled.div`
  padding: 2px 0;
`

type Props = {|
  url: string,
  name: string,
  login: string,
  password: string,
  nameErrors: Array<string>,
  urlErrors: Array<string>,
  loginErrors: Array<string>,
  passwordErrors: Array<string>,
  isOpen: boolean,
  isLoading: boolean,
  onClose: Function,
  onChange: Function,
  onPersist: Function
|}

const t = {
  modal_title: 'Создать прайс-лист',
  name: 'Название',
  url: 'URL файла',
  login: 'Логин',
  password: 'Пароль',
  save: 'Сохранить',
  hint: {
    text: 'Укажите ссылку на YML-файл с товарами вашего магазина.',
    more: 'Подробнее про формат файла можно',
    link_text: 'прочитать тут'
  }
}

export default class PricelistForm extends Component<Props> {
  render() {
    return (
      <Modal
        maxWidth={450}
        header={t.modal_title}
        isOpen={this.props.isOpen}
        hideBtn
        onClose={() => this.props.onClose()}
      >
        <TextWrapper className="t-PricelistForm">
          <HintText>{t.hint.text}</HintText>
          <HintText>
            {t.hint.more}
            <Link href="/ru/blog/dynamic-remarketing/" target="_blank">
              {t.hint.link_text}
            </Link>
          </HintText>
        </TextWrapper>
        <LabeledWrapper label={t.name} errors={this.props.nameErrors}>
          <TextInput
            className="t-PricelistName"
            disabled={this.props.isLoading}
            value={this.props.name}
            onChange={(e) => this.props.onChange({ name: e.target.value, nameErrors: [] })}
          />
        </LabeledWrapper>
        <LabeledWrapper label={t.url} errors={this.props.urlErrors}>
          <TextInput
            className="t-PricelistUrl"
            disabled={this.props.isLoading}
            value={this.props.url}
            onChange={(e) => this.props.onChange({ url: e.target.value, urlErrors: [] })}
          />
        </LabeledWrapper>
        <LabeledWrapper label={t.login} errors={this.props.loginErrors}>
          <TextInput
            className="t-PricelistLogin"
            disabled={this.props.isLoading}
            value={this.props.login}
            onChange={(e) => this.props.onChange({ login: e.target.value, loginErrors: [] })}
          />
        </LabeledWrapper>
        <LabeledWrapper label={t.password} errors={this.props.passwordErrors}>
          <TextInput
            className="t-PricelistPassword"
            disabled={this.props.isLoading}
            value={this.props.password}
            onChange={(e) => this.props.onChange({ password: e.target.value, passwordErrors: [] })}
          />
        </LabeledWrapper>
        <Button
          className="t-Create"
          onClick={() => this.props.onPersist()}
          disabled={this.props.isLoading}
        >
          {t.save}
        </Button>
      </Modal>
    )
  }
}
